/* eslint-disable camelcase */

import { checkIsMobile, getBrowserName } from './browserUtils'

import type AbTestType from 'types/AbTestType'
import { removeEmptyProperties } from './objectUtils'

export function getCommonTrackObject(activeAbTests?: AbTestType[]) {
  let cleanedAbTestArray

  if (activeAbTests !== undefined) {
    cleanedAbTestArray = activeAbTests.map(abTest => ({ name: abTest.name, variant: abTest.variant }))
  }

  return {
    is_mobile_device: checkIsMobile(),
    // eslint-disable-next-line deprecation/deprecation
    os: navigator?.userAgentData?.platform || navigator.platform,
    screen_width: window.screen.width,
    screen_height: window.screen.height,
    active_ab_tests: cleanedAbTestArray,
    browser: getBrowserName()
  }
}

export const getTrackObject = (
  section: string,
  action: string,
  target: string,
  goal: string,
  content: string,
  destination?: string,
  activeAbTests?: AbTestType[]
) =>
  removeEmptyProperties({ ...getCommonTrackObject(activeAbTests), section, action, target, goal, content, destination })
